import _ from 'lodash'
import { Component, createElement } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
// import { Route } from 'react-router-dom'

// helpers to get commected and decorated Components
// here are implemented simple selectorFactories or
// mapStateToProps and mapDispatchToProps
// and other simple decorating HOC
export const withOnlyNotBusyUpdate = (WrappedComponent) => {
  const wrappedComponentName = WrappedComponent.displayName
                            || WrappedComponent.name
                            || 'Component'

  class OnlyNotBusyUpdate extends Component {
    getDisplayName (name) { return `ONBU(${name})`}
    shouldComponentUpdate(props, state, context) {
      let n = `${this.getDisplayName(wrappedComponentName)}`
      console.log(`${n} should updadate`, props, state, context)
      return !context.loader.isBusy
    }
    render () {
      console.log('ONBU render')
      return createElement(WrappedComponent, ...this.props)
    }
  }
  OnlyNotBusyUpdate.contextTypes = {
    app: PropTypes.shape({
      loader: PropTypes.shape({
        isBusy: PropTypes.bool
      })
    })
  }
  return OnlyNotBusyUpdate
}


const defaultConnectOptions = (
  process.env.NODE_ENV === 'production' ? {} : {
    renderCountProp: 'renderedCount',
    withRef: true
  })

export const mapStateToPropsHelper = (propsNames) => {
  return (state, ownProps) => {
    let cache = {}
    let funcProps = _
      .isArray(propsNames) ? _.intersection(
        propsNames, _.functions(ownProps)) : _.functions(ownProps)

    return (state) => {
      let changed = false
      _.forEach(funcProps, name => {
        if (ownProps[name].length === 1) {
          let value = ownProps[name](state)
          if (cache[name] !== value) {
            changed = true
            cache[name] = value
          }
        }
      })
      if (changed)
        return _.extend({}, cache)
      return cache
    }
  }
}

export const cachedConnect = (
  mapStateToProps,
  mapStateToDispatch,
  mergePropts,
  options
) => {
  let propsFromStateNames = _.isArray(mapStateToProps) ? mapStateToProps : false
  // if mapStateToProps takes 3 params, the 3rd one is a reference to a cache, to use as cacheState
  // the signature is assumed to be (state, ownProps, cacheForState)
  // make a cached state, as 3rd params to use as cachedState, available to mapStateToProps
  let mapStateToPropsWithCachedState = (
    (!propsFromStateNames && _.isFunction(mapStateToProps) && mapStateToProps.length > 2) ? (state, ownProps) => {
      let cache = {}
      return mapStateToProps(state, ownProps, { cachedState: cache })
    } : false)
  return connect(
    (propsFromStateNames ? mapStateToPropsHelper(propsFromStateNames) : mapStateToPropsWithCachedState ? mapStateToPropsWithCachedState : mapStateToProps),
    mapStateToDispatch,
    mergePropts,
    { ...defaultConnectOptions, methodName: 'cachedConnect',
      getDisplayName: name => `C(${name})`, options })
}



// WEBPACK FOOTER //
// ./src/containers/helpersHOC.js